import loadable from '@loadable/component';

export const T3SiteWrapper = loadable(
  () => import(/* webpackChunkName: "t3-site" */ './T3SiteWrapper'),
);
